// extracted by mini-css-extract-plugin
export default {"container":"Tecnico_container__W4ARu","containerInfo":"Tecnico_containerInfo__oeQ1q"};